import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// action creators
import { appointmentCancel, appointmentConfirm } from '../../../actions/appointmentActions';
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';

class ConfirmCancelAppointmentModal extends React.Component {
  static propTypes = {
    appointmentId:      PropTypes.string,
    cancelAppointment:  PropTypes.func.isRequired,
    confirmAppointment: PropTypes.func.isRequired,
    hideTooltip:        PropTypes.func.isRequired,
    id:                 PropTypes.string,
    redirect:           PropTypes.func.isRequired,
    type:               PropTypes.string.isRequired

  }

  componentWillUnmount() {
    this._handleHideModal();
  }

  render() {
    const { id, type } = this.props;

    return (
      <Modal id={ id }>
        <div className='modal__header'>
          Are you sure?
        </div>

        <div>
          Are you sure you want to {type} this appointment?
        </div>

        <div className='modal__actions'>
          <Button className='form__button form__button--purple' onClick={ this._handleAppointmentAction } type='button'>Yes</Button>
          <Button className='form__button form__button--green' onClick={ this._handleHideModal } type='button'>No</Button>
        </div>
      </Modal>
    );
  }

  // private

  _handleHideModal          = this._handleHideModal.bind(this);

  _handleAppointmentAction = () => {
    const { appointmentId, cancelAppointment, confirmAppointment, type } = this.props;

    if (type === 'cancel') {
      cancelAppointment(appointmentId, '/reps/calendar');
    } else if (type === 'confirm') {
      confirmAppointment(appointmentId, '/reps/calendar');
    }
  }

  _handleHideModal() {
    const { hideTooltip, id } = this.props;

    hideTooltip(id);
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cancelAppointment: (id, redirectUrl) => {
      dispatch(appointmentCancel({ id, redirectUrl }));
    },

    confirmAppointment: (id, redirectUrl) => {
      dispatch(appointmentConfirm({ id, redirectUrl}));
    },

    hideTooltip: (id) => {
      dispatch(tooltipHide({ id: id }));
    },

    redirect: (url) => {
      dispatch(push(url));
    }
  };
};

export default connect(null, mapDispatchToProps)(ConfirmCancelAppointmentModal);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_ConfirmCancelAppointmentModal.jsx